import { Link } from "react-router-dom";
import { BookOpen, Clapperboard, Volume2, MessageSquare, Languages, HeartHandshake, ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import Reveal from "../components/Reveal";
import Marquee from "../components/Marquee";

const FEATURES = [
  { icon: BookOpen, t: "bo_f1t", d: "bo_f1d" },
  { icon: Clapperboard, t: "bo_f2t", d: "bo_f2d" },
  { icon: Volume2, t: "bo_f3t", d: "bo_f3d" },
  { icon: MessageSquare, t: "bo_f4t", d: "bo_f4d" },
  { icon: Languages, t: "bo_f5t", d: "bo_f5d" },
  { icon: HeartHandshake, t: "bo_f6t", d: "bo_f6d" },
];

const BookOnline = () => {
  const { t } = useLang();

  return (
    <main className="pt-16" data-testid="book-online-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(ellipse 70% 55% at 50% 0%, rgba(255,85,0,0.12), transparent 70%)" }} />
        <div className="relative max-w-4xl mx-auto px-5 sm:px-8 pt-20 pb-14 text-center">
          <Reveal>
            <p className="font-mono2 text-xs tracking-[0.35em] uppercase text-ember mb-5" data-testid="bo-kicker">{t("bo_kicker")}</p>
            <h1 className="font-display font-extrabold text-3xl sm:text-5xl tracking-tight leading-tight mb-6" data-testid="bo-title">
              {t("bo_title")}
            </h1>
            <p className="text-mist text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-testid="bo-sub">{t("bo_sub")}</p>
          </Reveal>
        </div>
      </section>

      <Marquee text={t("marquee")} />

      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="bo-features">
          {FEATURES.map((f, i) => (
            <Reveal key={f.t} delay={i * 0.06}>
              <div className="rounded-2xl border border-white/10 bg-card p-7 h-full hover:border-ember/50 transition-colors">
                <f.icon className="w-6 h-6 text-ember mb-4" />
                <h3 className="font-display font-bold text-lg mb-2">{t(f.t)}</h3>
                <p className="text-sm text-mute leading-relaxed">{t(f.d)}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="text-center mt-16" data-testid="bo-cta-block">
            <Link to="/contatti" data-testid="bo-cta"
              className="inline-flex items-center gap-2 rounded-full bg-ember px-9 py-4 text-sm font-semibold uppercase tracking-wider text-black hover:bg-gold transition-colors">
              {t("bo_cta")} <ArrowRight className="w-4 h-4" />
            </Link>
            <p className="text-mute text-xs mt-5">{t("bo_cta_sub")}</p>
          </div>
        </Reveal>
      </section>
    </main>
  );
};

export default BookOnline;
